import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useState, memo } from 'react';
import FontAwesome from 'react-fontawesome';
import Field from "./Field";
import { FieldDiffWrapper, FlexDiffContent, Button, ChangeIndicator } from "./style";
var Diff = function Diff(_ref) {
  var onCommit = _ref.onCommit,
    onReject = _ref.onReject,
    children = _ref.children;
  if (children == null) return null;
  return /*#__PURE__*/React.createElement(FieldDiffWrapper, null, /*#__PURE__*/React.createElement(FlexDiffContent, null, children), /*#__PURE__*/React.createElement(Button, {
    onClick: onCommit,
    success: true
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "check"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: onReject,
    destructive: true
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "times"
  })));
};
var FieldWithDiff = function FieldWithDiff(_ref2) {
  var title = _ref2.title,
    children = _ref2.children,
    diffKey = _ref2.diffKey,
    diffValue = _ref2.diffValue,
    onCommit = _ref2.onCommit,
    committed = _ref2.committed;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleCommit = useCallback(function () {
    setExpanded(false);
    onCommit(diffKey, true);
  }, [diffKey, onCommit, setExpanded]);
  var handleReject = useCallback(function () {
    setExpanded(false);
    onCommit(diffKey, false);
  }, [diffKey, onCommit, setExpanded]);
  var handleExpand = useCallback(function () {
    setExpanded(true);
  }, [setExpanded]);
  var content;
  if (committed) {
    content = diffValue;
  } else if (expanded) {
    content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement(Diff, {
      onCommit: handleCommit,
      onReject: handleReject,
      committed: committed
    }, diffValue));
  } else {
    var changeIndicator = diffValue ? /*#__PURE__*/React.createElement(ChangeIndicator, {
      onClick: handleExpand
    }, /*#__PURE__*/React.createElement(FontAwesome, {
      name: "exclamation-triangle"
    })) : null;
    content = /*#__PURE__*/React.createElement("div", null, children, " ", changeIndicator);
  }
  return /*#__PURE__*/React.createElement(Field, {
    title: title
  }, content);
};
export default /*#__PURE__*/memo(FieldWithDiff);